export default "__VITE_ASSET__G$qaT38q__"